function Footer() {
    return (
        <footer className="overflow-hidden bg-[#030014]">
            <hr className="border-gray-400 opacity-15" />
            <div className="py-4 flex justify-center">
                <span className="text-gray-400 font-semibold text-sm">© 2025 Long09.All Rights Reserved.</span>
            </div>
        </footer>
    );
}
export default Footer;
